export function uniqStrings(arr) {
    return Array.from(
      new Set((arr || []).map((x) => String(x || "").trim()).filter(Boolean))
    );
  }
  
  export function arrayMove(arr, from, to) {
    const copy = [...arr];
    const [item] = copy.splice(from, 1);
    copy.splice(to, 0, item);
    return copy;
  }
  